<figcaption class="bulb-caption-title"
  [ngClass]="{'bulb-caption-cursor' : editable, 'ck-placeholder' : !caption}"
  (click)="openCaptionDialog($event)">{{captionText}}</figcaption>
